import React from 'react';
import PropTypes from 'prop-types';

const BreadcrumbNext = ({ color = '#BCC6CA', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 18" width={10} height={18} fill="none" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.667 9.334 1 1.667M8.667 9.333 1 17"
    />
  </svg>
);

BreadcrumbNext.propTypes = {
  color: PropTypes.string
};

export default BreadcrumbNext;
